// accessToken 存储（JWT 双轨迁移·阶段2）
// localStorage 优先；隐私模式/webview 禁用时静默降级到内存（此时靠 rtCode cookie 经 refresh 兜底，
// 见 plans 阶段2.4 与真机验收清单「SafeStorage 降级」场景）。
const KEY = 'yxdj_at';

let memory = null;

function ls() {
  try {
    const s = window.localStorage;
    s.getItem(KEY); // Safari 隐私模式访问即抛，用于探测
    return s;
  } catch (e) {
    return null;
  }
}

export const tokenStore = {
  get() {
    const s = ls();
    return (s && s.getItem(KEY)) || memory || '';
  },
  set(token) {
    memory = token || null;
    try { ls()?.setItem(KEY, token); } catch (e) { /* 内存兜底已写 */ }
  },
  clear() {
    memory = null;
    try { ls()?.removeItem(KEY); } catch (e) { /* noop */ }
  },
};
